<template>
  <v-sheet class="d-flex ga-4 my-4">
    <v-select
      v-model="manualMode"
      :label="$t(props.field.properties.label)"
      :items="[
        { title: $t('components.fields.orderingField.setAtEnd'), value: false },
        {
          title: $t('components.fields.orderingField.setManually'),
          value: true,
        },
      ]"
      color="primary"
      hide-details
      @update:model-value="onInput"
    ></v-select>

    <!-- TODO :step="1" :min="0" -->
    <v-text-field
      v-if="model !== -1 && model !== null"
      v-model="model"
      :label="$t(props.field.properties.label)"
      hide-details
      single-line
      type="number"
      color="primary"
    />
  </v-sheet>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'

import { FormField } from '../formBuilderHelper'

type OrderingFieldProps = {
  field: FormField
  form: Record<string, any>
}

const model = defineModel<number>()
const props = defineProps<OrderingFieldProps>()
const manualMode = ref(false)
const originalOrder = ref<number>(null)

onMounted(() => {
  manualMode.value = model.value !== -1 && model.value !== null
  originalOrder.value = model.value
})

function onInput(value) {
  if (value === false) {
    model.value = -1
  } else {
    if (model.value === -1 || model.value === null) {
      if (originalOrder.value !== -1 && originalOrder.value !== null) {
        model.value = originalOrder.value
      } else {
        model.value = 0
      }
    }
  }
}
</script>
